
export enum AlertAnswerOrigin {
  Unknown = 1,
  User = 2,
  Admin = 3,
  Support = 4,
  Automatic = 5
}
